export default __webpack_public_path__ + "static/avenir-next-bold-53c5101c128b8844c3f5511a0d493bb3.woff2";